<template>
  <div class="mb-6">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ title }}</h3>
    <div class="flex flex-col gap-4">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-3 rounded-lg border-l-4 p-4"
        :class="itemClasses"
      >
        <span class="text-xl shrink-0 mt-0.5">{{ item.icon }}</span>
        <div>
          <p class="font-semibold text-gray-900">{{ item.title }}</p>
          <MarkdownText :content="item.description" class="text-sm text-gray-600 mt-0.5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MarkdownText } from "@estaly/ui";

export default {
  name: "CoverageList",
  components: { MarkdownText },
  props: {
    title: { type: String, default: "" },
    coverageStyle: { type: String, default: "covered" },
    items: { type: Array, required: true },
  },
  computed: {
    itemClasses() {
      const styles = {
        covered: "border-green-500 bg-green-50",
        not_covered: "border-red-500 bg-red-50",
      };
      return styles[this.coverageStyle] || styles.covered;
    },
  },
};
</script>
